import { clsx } from "clsx"
import { ReactNode, useState } from "react"
import { Collapse } from "src/components/collapse"

interface Props {
  title: string
  children: ReactNode
}
export const FAQCollapse = ({ title, children }: Props) => {
  const [open, setOpen] = useState(false)
  return (
    <div className="iban-faq-collapse">
      <div
        className={clsx("iban-faq-collapse__header", {
          opened: open,
        })}
        onClick={() => setOpen(!open)}
      >
        <span className="title">{title}</span>
        <svg
          style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.6668 18.3335L22.0002 25.6668L29.3335 18.3335"
            stroke="#323232"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <Collapse open={open}>
        <div className="iban-faq-collapse__content">{children}</div>
      </Collapse>
    </div>
  )
}
